import React from 'react';
import ApiForm from './Components/ApiForm';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App">
      <ApiForm />
      <Footer />
    </div>
  );
}

export default App;
